import { getComposerListAction, getComposerSearchListAction, clearComposersSearchAction } from './actions';
import { defaultListParams, listReducer } from '../../utils/crudUtils';

export const key = 'Composers';

export const initialState = {
  composers: defaultListParams,
  searchList: defaultListParams,
};

const composersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getComposerListAction.TRIGGER:
    case getComposerListAction.SUCCESS:
    case getComposerListAction.FAILURE:
      return listReducer(state, type, payload, 'composers');

    case getComposerSearchListAction.TRIGGER:
    case getComposerSearchListAction.SUCCESS:
    case getComposerSearchListAction.FAILURE:
      return listReducer(state, type, payload, 'searchList');

    case clearComposersSearchAction.TRIGGER:
      return { ...state, searchList: [] };

    default:
      return state;
  }
};

export default composersReducer;
